<template>
  <div>
    <reports :reports="reports" :reportType="reportType" :reportLabel="reportLabel" :filter="selectedFilter" />
  </div>
</template>

<script>
export default {
  props: {
    reports: null,
    reportType: null,
    reportLabel: null,
    selectedFilter: null
  }
}
</script>

<style lang="css">
</style>
